
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mapzN7nkskE4nID_45KJENReFFvzu2qn9E1YNLot9O5S3_pgMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/embed/map.vue?macro=true";
import { default as legal_45noticeUUtQ_F2M_45m9YzlRgqbJK4NmQn6lYp4IF3VM_2xYlMBgMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/legal-notice.vue?macro=true";
import { default as mapZb2qI5KYYgi_sWNl8_45lOsnkPDyUsZnPvMQG3BSu0cPwMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/map.vue?macro=true";
import { default as indexXrRpxFFW0dcPtv6agor_xG3AvyXyiA_WAnva_9HMVVcMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/index.vue?macro=true";
import { default as tripscEbV34AoBQQXxEKb_45q5n8_45g9GcUaa_V9N3y0hBecnikMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/trips.vue?macro=true";
import { default as helpINZszc_45iqkh7vrB4RFvFvTZDJe5rJNu9TRp_v6ik3E4Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/help.vue?macro=true";
import { default as privacy_45policyaSIu0F4_45q_459dy_45tVypKAxx7fO30UAv2WkdD6phk5FBsMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/privacy-policy.vue?macro=true";
import { default as aboutBYYcKCi16MaUWE6l7_45pC9BHHECKcHAM4kkBtSU8m1KIMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/about.vue?macro=true";
import { default as indexqwcdJcVGu2MshXW_OjaydQk14z63Y072iO8NYvetB8gMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/index.vue?macro=true";
import { default as _91slug_93TGDkaUfBln7b9PmdVPQM5Y9NERk4rODBuL6EA7dPR9sMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/[slug].vue?macro=true";
import { default as discover0zLbY8xl1aOpk6IBqhPbnL7Q4sIXkAAOO_455v0qpc9msMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/discover.vue?macro=true";
import { default as leasingLeV4cqAIfMFdv4RevhBfcP9fzqH8OdZ4fUkQpNfI_JQMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/referral/leasing.vue?macro=true";
import { default as sharingFmIRSp8uzE97MmTolfIMfDY3FhcDKYLWCzX1OXPEAR0Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/referral/sharing.vue?macro=true";
import { default as leasing3FWcpRa9gIpwVUG2YyEbSffpmuN_9v6feMUPS_xzxJ4Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/leasing.vue?macro=true";
import { default as sharingFR_yoNVoGh0ALj86tMwakpXFbUNCp17RkWD_45wujOiqcMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/sharing.vue?macro=true";
import { default as indexbY_VwmtoQ38nSEG_45PDdL_kQSPDMtq4wWzRbUfUEIzJ8Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/auth/index.vue?macro=true";
import { default as _91id_93G6qBGFygTgJ73LASqAmNlg0NerL8KdB_45rcPOMrgJm1oMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/offers/[id].vue?macro=true";
import { default as indexO17mNqYJRsoRqVAcOUbzVE_kxL__45Gsx_45aDyFZXksmqIMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/blog/index.vue?macro=true";
import { default as indexeN4M4Rm9Ic0KyYtDqQ4QhWAnq7wO_q_45x7XMDFeEKgosMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/offers/index.vue?macro=true";
import { default as _91slug_931Hu_rjfavylBgZf0D8jrmyoonjeSZLNGMkMsiQDZin4Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/showcase/blog/[slug].vue?macro=true";
import { default as terms_45and_45conditionsSHzS0Ah8S1E3MLn_hDoTKfUDrpkDlRIIkAYZAFcc4tMMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/terms-and-conditions.vue?macro=true";
import { default as indexalY8zvo3nDcDi0EyofS6ZPovSAGXaGrt3BfDbozP_hgMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/account-settings/index.vue?macro=true";
import { default as indexaEae8ifPxmtcu9Pb5_45ajZEdMQaSfHCzmmlM_tOMrnu0Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/payments/index.vue?macro=true";
import { default as indexqtenIspRPxt9dRtXH8WSmV9lAJ0zyJUzzHv8EHYT3MIMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/index.vue?macro=true";
import { default as confirmationmaIN9ZTWtjAcm5vR0Cedh3XZtpHfWF2k_1ZD_AHScEMMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/auth/confirmation.vue?macro=true";
import { default as identityXuNnVP84Yy3f7dXW_oxviUMUsNVAEvEp2ZAAT4oJJ_45AMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/identity.vue?macro=true";
import { default as indexb5y5Lfda11YabiN0ypjgYz_45aiQ7JcodnLr4Wj_YfMZ8Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/account-settings/auth/index.vue?macro=true";
import { default as confirmationdjwDby5s6Fm6etiQ4etVcsoBBs4fXvRkAIe2pvjEt3cMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/confirmation.vue?macro=true";
import { default as indexDtMPZdC0rLWLoksR03RWwUAML86NQM_45MvlKMO_45cnnJwMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/communication-preferences/index.vue?macro=true";
import { default as payment_45methodWK5DyurR9i6bZfP6UFRZeZusurKaiguZy6MYtXKqzVgMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/payment-method.vue?macro=true";
import { default as transport_45cardQZkNjXc0hxJeakn8F120VWnMeu__45K7Vzcn_lFXA7vRsMeta } from "/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/transport-card.vue?macro=true";
import { default as confirmationFAUio3RAXdAdMfnFyaxkTH3QWernBL7wY0CB7ZFCl20Meta } from "/tmp/build/ad8838f6/customer-website-pr/pages/account-settings/auth/confirmation.vue?macro=true";
import { default as component_45stubMzmQVKKH5bbiPPxBI95TpOi6o0havyw8_45h1FiKZr9xsMeta } from "/tmp/build/ad8838f6/customer-website-pr/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.4.1_@types+node@22.14.1_db0@0.3.1_eslint@8.57.1_idb-keyval@6.2._yhgabb7n53rapqrwhb27gmpsg4/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubMzmQVKKH5bbiPPxBI95TpOi6o0havyw8_45h1FiKZr9xs } from "/tmp/build/ad8838f6/customer-website-pr/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.4.1_@types+node@22.14.1_db0@0.3.1_eslint@8.57.1_idb-keyval@6.2._yhgabb7n53rapqrwhb27gmpsg4/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "embed-map",
    path: "/embed/map",
    meta: mapzN7nkskE4nID_45KJENReFFvzu2qn9E1YNLot9O5S3_pgMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/embed/map.vue")
  },
  {
    name: "unlocalized-legal-notice",
    path: "/legal-notice",
    meta: legal_45noticeUUtQ_F2M_45m9YzlRgqbJK4NmQn6lYp4IF3VM_2xYlMBgMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/legal-notice.vue")
  },
  {
    name: "unlocalized-showcase-map",
    path: "/map",
    meta: mapZb2qI5KYYgi_sWNl8_45lOsnkPDyUsZnPvMQG3BSu0cPwMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/map.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexXrRpxFFW0dcPtv6agor_xG3AvyXyiA_WAnva_9HMVVcMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/index.vue")
  },
  {
    name: "profile-trips",
    path: "/profile/trips",
    meta: tripscEbV34AoBQQXxEKb_45q5n8_45g9GcUaa_V9N3y0hBecnikMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/trips.vue")
  },
  {
    name: "unlocalized-showcase-help",
    path: "/help",
    meta: helpINZszc_45iqkh7vrB4RFvFvTZDJe5rJNu9TRp_v6ik3E4Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/help.vue")
  },
  {
    name: "unlocalized-privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyaSIu0F4_45q_459dy_45tVypKAxx7fO30UAv2WkdD6phk5FBsMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/privacy-policy.vue")
  },
  {
    name: "unlocalized-showcase-about",
    path: "/about",
    meta: aboutBYYcKCi16MaUWE6l7_45pC9BHHECKcHAM4kkBtSU8m1KIMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/about.vue")
  },
  {
    name: "unlocalized-showcase",
    path: "/",
    meta: indexqwcdJcVGu2MshXW_OjaydQk14z63Y072iO8NYvetB8gMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/index.vue")
  },
  {
    name: "unlocalized-showcase-slug",
    path: "/:slug()",
    meta: _91slug_93TGDkaUfBln7b9PmdVPQM5Y9NERk4rODBuL6EA7dPR9sMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/[slug].vue")
  },
  {
    name: "profile-discover",
    path: "/profile/discover",
    meta: discover0zLbY8xl1aOpk6IBqhPbnL7Q4sIXkAAOO_455v0qpc9msMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/discover.vue")
  },
  {
    name: "unlocalized-referral-leasing",
    path: "/referral/leasing",
    meta: leasingLeV4cqAIfMFdv4RevhBfcP9fzqH8OdZ4fUkQpNfI_JQMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/referral/leasing.vue")
  },
  {
    name: "unlocalized-referral-sharing",
    path: "/referral/sharing",
    meta: sharingFmIRSp8uzE97MmTolfIMfDY3FhcDKYLWCzX1OXPEAR0Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/referral/sharing.vue")
  },
  {
    name: "unlocalized-showcase-leasing",
    path: "/leasing",
    meta: leasing3FWcpRa9gIpwVUG2YyEbSffpmuN_9v6feMUPS_xzxJ4Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/leasing.vue")
  },
  {
    name: "unlocalized-showcase-sharing",
    path: "/sharing",
    meta: sharingFR_yoNVoGh0ALj86tMwakpXFbUNCp17RkWD_45wujOiqcMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/sharing.vue")
  },
  {
    name: "profile-auth",
    path: "/profile/auth",
    meta: indexbY_VwmtoQ38nSEG_45PDdL_kQSPDMtq4wWzRbUfUEIzJ8Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/auth/index.vue")
  },
  {
    name: "profile-offers-id",
    path: "/profile/offers/:id()",
    meta: _91id_93G6qBGFygTgJ73LASqAmNlg0NerL8KdB_45rcPOMrgJm1oMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/offers/[id].vue")
  },
  {
    name: "unlocalized-showcase-blog",
    path: "/blog",
    meta: indexO17mNqYJRsoRqVAcOUbzVE_kxL__45Gsx_45aDyFZXksmqIMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/blog/index.vue")
  },
  {
    name: "profile-offers",
    path: "/profile/offers",
    meta: indexeN4M4Rm9Ic0KyYtDqQ4QhWAnq7wO_q_45x7XMDFeEKgosMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/offers/index.vue")
  },
  {
    name: "unlocalized-showcase-blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_931Hu_rjfavylBgZf0D8jrmyoonjeSZLNGMkMsiQDZin4Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/blog/[slug].vue")
  },
  {
    name: "unlocalized-terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditionsSHzS0Ah8S1E3MLn_hDoTKfUDrpkDlRIIkAYZAFcc4tMMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/terms-and-conditions.vue")
  },
  {
    name: "account-settings",
    path: "/account-settings",
    meta: indexalY8zvo3nDcDi0EyofS6ZPovSAGXaGrt3BfDbozP_hgMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/account-settings/index.vue")
  },
  {
    name: "profile-payments",
    path: "/profile/payments",
    meta: indexaEae8ifPxmtcu9Pb5_45ajZEdMQaSfHCzmmlM_tOMrnu0Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/payments/index.vue")
  },
  {
    name: "profile-register",
    path: "/profile/register",
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/index.vue")
  },
  {
    name: "profile-auth-confirmation",
    path: "/profile/auth/confirmation",
    meta: confirmationmaIN9ZTWtjAcm5vR0Cedh3XZtpHfWF2k_1ZD_AHScEMMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/auth/confirmation.vue")
  },
  {
    name: "profile-register-identity",
    path: "/profile/register/identity",
    meta: identityXuNnVP84Yy3f7dXW_oxviUMUsNVAEvEp2ZAAT4oJJ_45AMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/identity.vue")
  },
  {
    name: "account-settings-auth",
    path: "/account-settings/auth",
    meta: indexb5y5Lfda11YabiN0ypjgYz_45aiQ7JcodnLr4Wj_YfMZ8Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/account-settings/auth/index.vue")
  },
  {
    name: "profile-register-confirmation",
    path: "/profile/register/confirmation",
    meta: confirmationdjwDby5s6Fm6etiQ4etVcsoBBs4fXvRkAIe2pvjEt3cMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/confirmation.vue")
  },
  {
    name: "communication-preferences",
    path: "/communication-preferences",
    meta: indexDtMPZdC0rLWLoksR03RWwUAML86NQM_45MvlKMO_45cnnJwMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/communication-preferences/index.vue")
  },
  {
    name: "profile-register-payment-method",
    path: "/profile/register/payment-method",
    meta: payment_45methodWK5DyurR9i6bZfP6UFRZeZusurKaiguZy6MYtXKqzVgMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/payment-method.vue")
  },
  {
    name: "profile-register-transport-card",
    path: "/profile/register/transport-card",
    meta: transport_45cardQZkNjXc0hxJeakn8F120VWnMeu__45K7Vzcn_lFXA7vRsMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/profile/register/transport-card.vue")
  },
  {
    name: "account-settings-auth-confirmation",
    path: "/account-settings/auth/confirmation",
    meta: confirmationFAUio3RAXdAdMfnFyaxkTH3QWernBL7wY0CB7ZFCl20Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/account-settings/auth/confirmation.vue")
  },
  {
    name: "legal-notice",
    path: "/:locale(ast|de|en|es|fr|it|pt)/legal-notice",
    meta: legal_45noticeUUtQ_F2M_45m9YzlRgqbJK4NmQn6lYp4IF3VM_2xYlMBgMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/legal-notice.vue")
  },
  {
    name: "showcase-map",
    path: "/:locale(ast|de|en|es|fr|it|pt)/map",
    meta: mapZb2qI5KYYgi_sWNl8_45lOsnkPDyUsZnPvMQG3BSu0cPwMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/map.vue")
  },
  {
    name: "showcase-help",
    path: "/:locale(ast|de|en|es|fr|it|pt)/help",
    meta: helpINZszc_45iqkh7vrB4RFvFvTZDJe5rJNu9TRp_v6ik3E4Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/help.vue")
  },
  {
    name: "privacy-policy",
    path: "/:locale(ast|de|en|es|fr|it|pt)/privacy-policy",
    meta: privacy_45policyaSIu0F4_45q_459dy_45tVypKAxx7fO30UAv2WkdD6phk5FBsMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/privacy-policy.vue")
  },
  {
    name: "showcase-about",
    path: "/:locale(ast|de|en|es|fr|it|pt)/about",
    meta: aboutBYYcKCi16MaUWE6l7_45pC9BHHECKcHAM4kkBtSU8m1KIMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/about.vue")
  },
  {
    name: "showcase",
    path: "/:locale(ast|de|en|es|fr|it|pt)/",
    meta: indexqwcdJcVGu2MshXW_OjaydQk14z63Y072iO8NYvetB8gMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/index.vue")
  },
  {
    name: "showcase-slug",
    path: "/:locale(ast|de|en|es|fr|it|pt)/:slug()",
    meta: _91slug_93TGDkaUfBln7b9PmdVPQM5Y9NERk4rODBuL6EA7dPR9sMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/[slug].vue")
  },
  {
    name: "referral-leasing",
    path: "/:locale(ast|de|en|es|fr|it|pt)/referral/leasing",
    meta: leasingLeV4cqAIfMFdv4RevhBfcP9fzqH8OdZ4fUkQpNfI_JQMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/referral/leasing.vue")
  },
  {
    name: "referral-sharing",
    path: "/:locale(ast|de|en|es|fr|it|pt)/referral/sharing",
    meta: sharingFmIRSp8uzE97MmTolfIMfDY3FhcDKYLWCzX1OXPEAR0Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/referral/sharing.vue")
  },
  {
    name: "showcase-leasing",
    path: "/:locale(ast|de|en|es|fr|it|pt)/leasing",
    meta: leasing3FWcpRa9gIpwVUG2YyEbSffpmuN_9v6feMUPS_xzxJ4Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/leasing.vue")
  },
  {
    name: "showcase-sharing",
    path: "/:locale(ast|de|en|es|fr|it|pt)/sharing",
    meta: sharingFR_yoNVoGh0ALj86tMwakpXFbUNCp17RkWD_45wujOiqcMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/sharing.vue")
  },
  {
    name: "showcase-blog",
    path: "/:locale(ast|de|en|es|fr|it|pt)/blog",
    meta: indexO17mNqYJRsoRqVAcOUbzVE_kxL__45Gsx_45aDyFZXksmqIMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/blog/index.vue")
  },
  {
    name: "showcase-blog-slug",
    path: "/:locale(ast|de|en|es|fr|it|pt)/blog/:slug()",
    meta: _91slug_931Hu_rjfavylBgZf0D8jrmyoonjeSZLNGMkMsiQDZin4Meta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/showcase/blog/[slug].vue")
  },
  {
    name: "terms-and-conditions",
    path: "/:locale(ast|de|en|es|fr|it|pt)/terms-and-conditions",
    meta: terms_45and_45conditionsSHzS0Ah8S1E3MLn_hDoTKfUDrpkDlRIIkAYZAFcc4tMMeta || {},
    component: () => import("/tmp/build/ad8838f6/customer-website-pr/pages/terms-and-conditions.vue")
  },
  {
    name: component_45stubMzmQVKKH5bbiPPxBI95TpOi6o0havyw8_45h1FiKZr9xsMeta?.name,
    path: "/profile/edit",
    component: component_45stubMzmQVKKH5bbiPPxBI95TpOi6o0havyw8_45h1FiKZr9xs
  }
]